import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import { padding } from '@mui/system';

const styles = StyleSheet.create({
   
    titleContainer:{
        flexDirection: 'row',
        marginTop: 10,
        marginBottom: 10,
        border: 1,
        borderColor: "#000",
        padding:10
    },
    reportTitle:{
        fontSize: 8,
        lineHeight:1.5
        // textAlign: 'center',
        // marginLeft: 'auto',
        // marginRight: 'auto'
    },
  });
  

  const InvoiceEmergency = () => (
    <View style={styles.titleContainer}>
        <Text style={styles.reportTitle}>Important Notes: {'\n'}   
            •	The hotel owner or experience provider may request a copy of your passport upon check in. {'\n'} 
            •	To avoid unnecessary charges please ensure that you are familiar with the service providers’ cancellation policy. {'\n'} 
            •	We strive to provide you with a quality service. If you see yourself not getting the service that you deserve please do give a call to our emergency number provided.</Text>
    </View>
  );
  
  export default InvoiceEmergency